import { OPEN_MODAL } from '../../actions/modal';
import { sendEvent } from '../sendEvent';

export const openModal = (name: string, data = {}) => {
  sendEvent(OPEN_MODAL, { name, data });
};
